<template>
  <Modal v-model="rechargeModal" class-name="rechargeStyle" :title="rechargeTitle" width="700"
    :transfer="false" :mask-closable="false" @on-visible-change="rechargeModalChange">
    <Form ref="rechargeForm" :model="rechargeForm" :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <Row style="width: 95%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003736')" prop="ymsDistributorMerchantId">
            <commonRemoteSelect
              ref="merchantSelect"
              :transfer="false"
              v-model="rechargeForm.ymsDistributorMerchantId"
              :request-fn="getMerchantPageList"
              :extra-params="merchantSearchParams"
              :debounceTime="1000"
              :placeholder="$t('key1003793')"
              :propsMap="{value: 'ymsMerchantId', label: 'ymsMerchantId'}"
              @on-change="selectChange"
            />
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="labelName_1" prop="currency" style="width: 660px;">
            <div class="flex align-items-center">
              <Select v-model="rechargeForm.currency" @on-change="selectCurrencyChange"
                transfer filterable :disabled="!rechargeForm.ymsDistributorMerchantId">
                <Option v-for="(item, index) in currencyList" :key="index" :value="item.value">{{ item.label }}</Option>
              </Select>
              <Tooltip max-width="280" placement="top" class="ml5 cursor" transfer
                :content="$t('key1003794')">
                <Icon size="22" type="md-help-circle"/>
              </Tooltip>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="labelName_2" class="required_style">
            <div class="denomination_box">
              <div
                v-for="(item, index) in denominationList"
                :class="{
                  'denomination_item': item.type === 'regular',
                  'custom_item': item.type === 'custom',
                  'active_style': item.select
                  }"
                :key="index" @click="selectRecharge(index)">
                <span v-if="item.type === 'regular'">{{ item.value }}</span>
                <div v-else>
                  <p class="custom_text">{{ $t('key1003797') }}</p>
                  <InputNumber style="width: 100px;" :min="1" :max="999999999" v-model="item.value" @on-change="changeCustomAmount"></InputNumber>
                </div>
              </div>
            </div>
            <div class="mt10" style="font-size: 13px;" v-show="rechargeForm.ymsDistributorMerchantId && rechargeForm.currency
            && !rechargeForm.currency.includes('_distributor')">
              <p style="line-height: 20px;">{{ realTimeExchangeRate }}</p>
              <p style="line-height: 20px;">{{ systemExchangeRate }}</p>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="optionsType === 'recharge'">
          <Form-item :label="$t('key1003795')" prop="paymentMethod">
            <Select v-model="rechargeForm.paymentMethod" filterable transfer>
              <Option v-for="(item, index) in paymentMethodList" :value="item.value" :key="index">{{ item.value }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="optionsType === 'recharge'">
          <Form-item :label="$t('key1003796')" prop="paymentSerialNumber">
            <Input v-model.trim="rechargeForm.paymentSerialNumber"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="optionsType === 'recharge'">
          <Form-item :label="$t('key1001494')" class="required_style_label">
            <div class="flex flex-wrap align-items-start">
              <template v-for="(item,index) in rechargeForm.paymentPicturePath">
                <div class="img_style" v-if="item.isImg">
                  <img :src="setImgPath(item.path)" alt=""/>
                  <Icon type="ios-close-circle" size="18" class="del-icon" @click="deleteImgBtn(item,index)"></Icon>
                </div>
                <div v-else class="filesBox">
                  <p class="filesItem">{{ item.name }}</p>
                  <Icon type="ios-close-circle" size="16" class="cursor ml6" style="position: relative; top: -1px;"
                    @click="deleteImgBtn(item,index)"></Icon>
                </div>
              </template>
              <Upload
                v-if="rechargeForm.paymentPicturePath.length <5"
                ref="uploadFiles"
                name="files"
                :headers="headObj"
                :max-size="uploadFilesMaxSize"
                :on-exceeded-size="uploadExceedSize"
                :show-upload-list="false"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :on-error="uploadFilesError"
                :action="uploadFilesUrl"
                multiple
                type="drag"
                style="display: inline-block;width:100px;">
                <div class="flex flex-direction justify-content-center align-items-center" style="height: 100px;">
                  <Icon type="ios-cloud-upload" size="34" style="color: #3399ff"></Icon>
                  <p style="font-size: 12px;">{{ $t('key1003798') }}</p>
                </div>
              </Upload>
            </div>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="optionsType === 'recharge'">
          <Form-item :label="$t('key1001495')" prop="remarks">
            <Input
              type="textarea"
              :autosize="{ minRows: 2,maxRows: 4 }"
              v-model.trim="rechargeForm.remarks">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-else>
          <Form-item :label="$t('key1001495')" prop="remark" class="required_style_label">
            <Input
              type="textarea"
              :autosize="{ minRows: 2,maxRows: 4 }"
              v-model.trim="rechargeForm.remark">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="rechargeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="rechargeBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {amountHandel, currencyNameCode, isImageFile} from "@/utils/common";
import commonRemoteSelect from "@/components/common/commonRemoteSelect.vue";

export default {
  name: "rechargeModal",
  components: {commonRemoteSelect},
  mixins: [Mixin],
  data() {
    return {
      uploadFilesUrl: api.post_uploadFiles + '?basePath=yms-core-service',
      rechargeModal: false,
      rechargeForm: {
        ymsDistributorMerchantId: null,
        currency: null, // 币种
        paymentMethod: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003778'),
        remarks: '',
        paymentSerialNumber: '',
        paymentPicturePath: [],
        remark: ''
      },
      paymentMethodList: [
        {value: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003778')}
      ],
      denominationList: [
        {type: 'regular', select: true, value: 100},
        {type: 'regular', select: false, value: 500},
        {type: 'regular', select: false, value: 1000},
        {type: 'custom', select: false, value: null},
      ],
      ruleValidate: {
        ymsDistributorMerchantId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003779'), trigger: 'change'}
        ],
        paymentMethod: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003780'), trigger: 'change'}
        ],
        paymentSerialNumber: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003781'), trigger: 'change'}
        ],
        currency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003782'), trigger: 'change'}
        ],
        remark: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003710'), trigger: 'blur'}
        ],
      },
      merchantSearchParams: {
        distributorAuditStatus: null,
        distributorMerchantGradeId: null,
        distributorMerchantGroupId: null,
        emails: [],
        labelNames: [],
        mobiles: [],
        registerEndTime: null,
        registerSource: null,
        registerStartTime: null,
        ymsMerchantIds: [],
      },
      realTimeExchangeRate: '',
      systemExchangeRate: '',
      distributorCurrency: null,
      selectCurrencyData: null,
      distributorCurrencyExchangeRate: null,
      uploadList: [],
      timer: null,
      maxUploadNum: 5,
      optionsType: 'recharge',
      rechargeTitle: '',
      currencyList: []
    };
  },
  computed: {
    labelName_1() {
      return this.optionsType === 'recharge' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003783') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003784');
    },
    labelName_2() {
      return this.optionsType === 'recharge' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003785') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003786');
    }
  },
  methods: {
    // 初始化接口数据
    initRechargeData(type) {
      let v = this;
      v.optionsType = type;
      let obj = {
        recharge: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003742'),
        charging: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003743')
      };
      v.rechargeTitle = obj[type];

      (async () => {
        await v.getExchangeRateConfigData();
        v.rechargeModal = true;
      })();
    },
    // 获取汇率配置的数据
    getExchangeRateConfigData() {
      let v = this;
      v.axios.get(api.get_ymsCurrencyConfig_query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            data.forEach((n, i) => {
              let label = n.targetCurrencyCode;
              if (n.currencyName) {
                label = label + '-' + n.currencyName;
              }
              n.label = label;
              n.value = n.targetCurrencyCode;
            });
            v.currencyList = data;
            let defaultCurrency = v.currencyState;
            v.currencyList.push({
              label: defaultCurrency + '-' + currencyNameCode(defaultCurrency, 'currencyCnName'),
              value: defaultCurrency,
              targetCurrencyCode: defaultCurrency
            });
          }
        }
      });
    },

    // 获取所有分销商商户号数据
    getMerchantPageList(params) {
      return this.axios.post(api.post_ymsDistributorMerchant_query, params);
    },
    // 充值弹窗的确定按钮
    rechargeBtn() {
      let v = this;
      let paymentPicturePathList = [];
      let {paymentPicturePath, remark, ...obj} = v.rechargeForm;
      let query = JSON.parse(JSON.stringify(obj));
      query.remarks = v.optionsType === 'recharge' ? obj.remarks : remark;
      for (let i = 0; i < v.denominationList.length; i++) {
        let item = v.denominationList[i];
        if (item.select) {
          if (item.value === '' || item.value === null) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003787'));
            return false;
          } else {
            query.rechargeAmount = item.value;
          }
        }
      }
      let currency = v.rechargeForm.currency ? v.rechargeForm.currency.split('_distributor')[0] : null;
      query.currency = currency;
      if (v.optionsType === 'recharge' && paymentPicturePath.length <= 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003788'));
        return false;
      } else {
        paymentPicturePath.map((item) => {
          paymentPicturePathList.push({
            name: item.name,
            paymentPicturePath: item.path
          });
        });
      }
      query.insertYmsDistributorMerchantRechargeRecordImageBos = paymentPicturePathList;

      let validateRules = JSON.parse(JSON.stringify(v.ruleValidate));
      if (v.optionsType === 'charging') {
        delete validateRules.paymentMethod;
        delete validateRules.paymentSerialNumber;
        delete validateRules.paymentPicturePath;
      } else {
        delete validateRules.remark;
      }
      let url = '';
      v.$refs['rechargeForm'].validate((valid) => {
        if (valid) {
          if (v.optionsType === 'charging') {
            url = api.post_ymsDistributorMerchantRechargeRecord_deductionOfFees;
            query.paymentMethod = '-';
            query.paymentSerialNumber = '-';
            delete query.insertYmsDistributorMerchantRechargeRecordImageBos;
          } else {
            url = api.post_ymsDistributorMerchantRechargeRecord_recharge;
          }
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.rechargeModal = false;
              v.$emit('updateData', true);
              let text = v.optionsType === 'charging' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003789') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003790');
              v.$Message.success(text);
            }
          });
        }
      });
    },
    // 选中充值面额
    selectRecharge(index) {
      this.denominationList.map((item, idx) => {
        item.select = false;
        if (item.type === 'custom') {
          item.value = null;
        }
        if (index === idx) {
          item.select = true;
          this.handleEexchangeRate(this.selectCurrencyData);
        }
      });
    },
    // 监听上传之前
    handleBeforeUpload(file) {
      let v = this;
      if (v.timer !== null) {
        clearTimeout(this.timer);
      }

      function hanldeData() {
        let newList = [...v.rechargeForm.paymentPicturePath, ...v.uploadList];
        v.timer = setTimeout(() => {
          if (newList.length > v.maxUploadNum) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003791'));
            v.timer = null;
            v.uploadList = [];
            return false;
          }
          v.uploadList.map((item) => {
            v.$refs['uploadFiles'].post(item); // 手动触发上传
          });
          v.uploadList = [];
          v.timer = null;
        }, 500);
      }

      v.uploadList.push(file);
      hanldeData();
      return false;
    },
    // 上传支付流水图片成功
    handleSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        let path = response.datas[0];
        let name = file.name;
        v.rechargeForm.paymentPicturePath.push({
          path: path,
          name: name,
          isImg: isImageFile(name)
        });
        let list = v.rechargeForm.paymentPicturePath.slice(0, v.maxUploadNum);
        v.rechargeForm.paymentPicturePath = list;
        v.$forceUpdate();
      }
    },
    // 监听充值弹窗
    rechargeModalChange(value) {
      let v = this;
      v.$nextTick(() => {
        v.$refs['rechargeForm'].resetFields();
        v.$refs['merchantSelect']?.clearOptions();
        v.rechargeForm.remarks = '';
      });
      if (!value) {
        v.denominationList.map((item) => {
          item.select = false;
          if (item.type === 'custom') {
            item.value = null;
          }
        });
        v.denominationList[0].select = true;
        v.uploadList = [];
        v.rechargeForm.paymentPicturePath = [];
      }
    },

    // 选中分销商商户号(通过商户号获取分销商设置的币种)
    selectChange(value) {
      let v = this;
      v.rechargeForm.currency = null;
      v.distributorCurrencyExchangeRate = null;
      if (value) {
        v.axios.get(api.get_ymsDistributorMerchant_queryDistributorMerchantCurrency + `?ymsDistributorMerchantId=${value}`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.distributorCurrency = data;
              let newList = v.currencyList.filter((item) => {
                return !item.value.includes('_distributor');
              });
              let obj = {
                label: data + '-' + currencyNameCode(data, 'currencyCnName') + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003792'),
                value: data + '_distributor',
                distributorCurrency: true
              };
              newList.unshift(obj);
              v.currencyList = v.uniqueFunc(newList, 'value');
              v.currencyList.map((item) => {
                if (item.targetCurrencyCode === data) {
                  v.distributorCurrencyExchangeRate = item;
                }
              });
              v.rechargeForm.currency = data + '_distributor';
            }
          }
        });
      }
    },
    // 输入自定义金额
    changeCustomAmount(value) {
      this.denominationList.map((item) => {
        item.select = false;
        if (item.type === 'custom') {
          item.select = true;
          item.value = value;
          this.handleEexchangeRate(this.selectCurrencyData);
        }
      });
    },
    // 选中充值币种
    selectCurrencyChange(value) {
      let v = this;
      v.selectCurrencyData = null;
      let newData = v.currencyList.filter((item) => {
        return !item.distributorCurrency;
      });
      if (newData.length > 0) {
        newData.map((item) => {
          if (item.targetCurrencyCode === value) {
            v.selectCurrencyData = item;
            v.handleEexchangeRate(item);
          }
        });
      }
    },
    // 处理汇率计算数据
    handleEexchangeRate(data) {
      let v = this;
      v.realTimeExchangeRate = '';
      v.systemExchangeRate = '';
      let sumList = v.denominationList.filter((item) => {
        return item.select;
      });
      if (sumList.length > 0) {
        let targetCurrencyCode = data && Object.keys(data).length > 0 ? data.targetCurrencyCode : 'CNY';
        let merchantExchangeRate = '';
        let space = ' ';
        if (targetCurrencyCode !== 'CNY') {
          // 当前分销商设置的币种汇率
          if (v.distributorCurrencyExchangeRate) {
            let exchangeRateNum = v.distributorCurrencyExchangeRate.merchantExchangeRate || '';
            if (exchangeRateNum) {
              let num = data.merchantExchangeRate / v.distributorCurrencyExchangeRate.merchantExchangeRate;
              merchantExchangeRate = amountHandel(num, 4);
            } else {
              merchantExchangeRate = amountHandel(data.merchantExchangeRate, 4);
            }
          }
        } else {
          merchantExchangeRate = v.distributorCurrencyExchangeRate && v.distributorCurrencyExchangeRate.merchantExchangeRate || 1;
        }
        let actualAmount = amountHandel((sumList[0].value * merchantExchangeRate), 4);
        let currency = currencyNameCode(v.distributorCurrency) || currencyNameCode(v.currencyState);
        v.realTimeExchangeRate = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003775')}${currency}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003776')} ${actualAmount}${space}${currency}`;
        v.systemExchangeRate = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003777')} ${targetCurrencyCode} = ${merchantExchangeRate}${space}${currency}`;
      }
    },
    // 移除上传的文件
    deleteImgBtn(item, index) {
      this.uploadList.splice(index, 1);
      this.rechargeForm.paymentPicturePath.splice(index, 1);
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  .rechargeStyle {
    .required_style {
      /deep/ .ivu-form-item-label:before {
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
      }
    }

    .denomination_box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .denomination_item {
        padding: 5px 25px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        border: 1px solid #dcdee2;
        background-color: #fff;
        color: #333;
        margin: 0 15px 15px 0;

        &:hover {
          border: 1px solid #2D8CF0;
        }
      }

      .custom_item {
        padding: 8px 18px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 17px;
        font-weight: bold;
        border: 1px solid #dcdee2;
        background-color: #fff;
        color: #333;
        margin: 0 15px 0 0;
        text-align: center;

        &:hover {
          border: 1px solid #2D8CF0;
        }
      }

      .active_style {
        color: #fff;
        background-color: #2D8CF0;
      }

      /deep/ .ivu-input-number-handler-wrap {
        display: none !important;
      }
    }

    .img_style {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #dcdee2;
      border-radius: 4px;
      text-align: center;
      overflow: hidden;
      margin: 0 15px 15px 0;
      position: relative;
      padding: 10px;
      box-sizing: border-box;

      img {
        width: 100%;
        height: auto;
        display: inline-block;
      }

      .del-icon {
        position: absolute;
        top: 1px;
        right: 1px;
        cursor: pointer;
      }
    }

    .filesBox {
      display: flex;
      align-items: center;
      margin-right: 15px;

      .filesItem {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        color: #333;
      }
    }
  }
}
</style>